import actionTypes from 'SRC/modules/redux/actionTypes'

export const setLoading = isLoading => ({
  type: actionTypes.SET_USERS_LIST_LOADING,
  payload: isLoading
})
